import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import Trans from 'Components/Trans';
import * as Styled from './styles';

const Questions = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.MGM);
  return (
    <Styled.Faq justify="center">
      <Styled.FaqContent direction="column" jusify="start">
        <Text type="fds_heading_bold_H5" color="dark_500" mb="fds_size_24">
          {t('Referral.Questions.Title')}
        </Text>
        <FlexContainer direction="column" gap="dimension_16">
          {Array.from({ length: 8 }).map((_, index: number) => (
            <Styled.FaqAccordion key={`Referral.Questions.${index + 1}.Title`} size="M">
              <Text type="paragraphs" size="M_L_M" color="dark">
                {t(`Referral.Questions.${index + 1}.Title`)}
              </Text>
              <Text type="paragraphs" size="S_M_M" color="dark">
                <Trans
                  i18nKey={`Referral.Questions.${index + 1}.Content`}
                  ns={locizeNS.MGM}
                  components={{
                    a: <Styled.Link />,
                    ol: <ol />,
                    li: <li />,
                    br: <br />,
                    span: <span />,
                  }}
                />
              </Text>
            </Styled.FaqAccordion>
          ))}
        </FlexContainer>
      </Styled.FaqContent>
    </Styled.Faq>
  );
};

export default Questions;
